import React from 'react';

const NUMBER_KEYS = '1234567890';

export function allowOnlyNumberKeys(
  event: React.KeyboardEvent<HTMLInputElement>
) {
  if (!NUMBER_KEYS.includes(event.key)) {
    event.preventDefault();
    return false;
  }
}
